const minigameData = {
	id: 'm3-alarm-brain-examples',
	title: 'Alamhjerneeksempler',
	playBtnText: 'Åbn opslagstavle',
	viewBtnText: 'Se elevsvar',
	parts: [
		{
			id: 1,
			type: 'brainstorm-simple',
			title: 'Alamhjerneeksempler',
			part1IntroPopupText: `Skriv et eksempel på noget, der kan aktivere alarmhjernen.
				<br /><br />Hver gang I har skrevet noget, så tryk på "Send - og skriv næste eksempel" for at sende den op på underviserens skærm.`,
			part1InfoPopupText: `Skriv et eksempel på noget, der kan aktivere alarmhjernen.`,
			placeholder: `Skriv et ord eller en sætning og tryk på "Send - og skriv næste eksempel".`,
			submitButton: 'Send - og skriv næste eksempel',
		},
	],
	
	submissions: {

	}
};

export {
	minigameData
}